<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card class="overflow-hidden" no-shadow>
		<template slot="actions">
			<div class="flex flex-row justify-between">
				<vs-dropdown>
					<vs-button
						:title="$t('CompanyConfigCrud')"
						class="mr-1"
						icon-pack="feather"
						icon="icon-more-vertical"
					>
					</vs-button>
					<vs-dropdown-menu class="w-64">
						<vs-dropdown-item @click.stop="goToConfig">
							<div class="flex items-center mt-2" :title="$t('CompanyConfigCrud')">
								<i class="material-icons"> settings </i>
								<span class="ml-2">{{ $t("Setting.Setting") }}</span>
							</div>
						</vs-dropdown-item>
						<vs-dropdown-group :vs-label="''">
							<vs-dropdown-item @click.stop="editData(item)">
								<div class="flex items-center">
									<i class="material-icons"> edit </i>
									<span>{{ $t("Crud.Update") }}</span>
								</div>
							</vs-dropdown-item>
							<vs-dropdown-item @click.stop="openConfirm(item.id)">
								<div class="flex items-center hover:text-danger stroke-current">
									<i class="material-icons"> delete </i>
									<span>{{ $t("Crud.Delete") }}</span>
								</div>
							</vs-dropdown-item>
						</vs-dropdown-group>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
		</template>

		<template slot="no-body">
			<div class="vx-row">
				<div class="vx-col sm:w-1/3 w-full flex items-center justify-center">
					<img :src="item.url_logo" :alt="item.name" class="logo" />
				</div>

				<!-- ITEM NAME & DESC COL -->
				<div class="vx-col sm:w-2/3">
					<h4 class="font-semibold hover:text-primary cursor-pointer" @click="createSitidata">
						{{ item.name }}
					</h4>

					<span class="font-semibold">{{ (item.city + " - " + item.address) | capitalize }}</span>

					<p class="mb-3">{{ item.description }}</p>
					<p>
						<span class="font-semibold cursor-pointer">{{ $t("ContactPerson") }}:</span>
						{{ item.contac_persons }}
					</p>
					<p>
						<span class="font-semibold cursor-pointer">{{ $t("Phone") }}:</span> {{ item.phone }}
					</p>

					<span class="font-semibold">{{ $t("Resource.Resources") }}:</span>
					<span class="font-semibold" v-if="!item.resource_typology_id">
						{{ item.total_resources }}
					</span>
					<span v-else> {{ $t("Resource.NotResources") }}</span>

					<div class="flex md:flex-row sm:flex-col justify-start mb-base mt-4">
						<vs-button
							v-if="!item.total_resources"
							icon-pack="feather"
							class="mr-1 sm:mt-1"
							icon="icon-user-plus"
							@click.stop="createAdminResource(item)"
							>{{ $t("Add") }} {{ $t("Resource.Resource") }}</vs-button
						>
						<vs-button
							icon-pack="feather"
							class="mr-1 sm:mt-1"
							icon="icon-plus"
							@click="createServiroute(item)"
							v-if="item.has_serviroutes === 0 && item.total_resources > 0"
							>{{ $t("Add") }} Serviroutes</vs-button
						>
						<vs-button
							icon-pack="feather"
							class="mr-1 sm:mt-1"
							icon="icon-plus"
							@click="createSitidata"
							v-if="item.has_sitidata === 0"
							>{{ $t("Add") }} Sitidata</vs-button
						>
					</div>
				</div>
			</div>
		</template>
	</vx-card>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			required: true,
		},
		editData: {
			type: Function,
			required: false,
		},
		openConfirm: {
			type: Function,
			required: false,
		},
		createAdminResource: {
			type: Function,
			required: false,
		},
		createServiroute: {
			type: Function,
			required: false,
		},
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		additemInCart(item) {
			this.$store.dispatch("eCommerce/additemInCart", item);
		},
		createSitidata() {
			this.$router
				.push({name: "app-setting", params: {company_id: this.item.id, config_type: "SITIDATA"}})
				.catch(() => {});
		},
		goToConfig() {
			this.$router
				.push({name: "app-setting", params: {company_id: this.item.id, config_type: "LIST"}})
				.catch(() => {});
		},
	},
};
</script>

<style lang="scss" scoped>
.logo {
	width: 150px;
	height: auto;
}
</style>
